<template>
  <div>
    <Nav></Nav>

    <mdb-container class="page-title pt-4">
      <mdb-row class="mb-4">
        <mdb-col md="12" class="text-left">
          <h1>Sales Podcasts</h1>
          <p>Keep up-to-date with the latest sales thinking with the industry leaders and disruptors</p>
        </mdb-col>
      </mdb-row>
    </mdb-container>

    <!-- Content docks -->
    <mdb-container fluid class>
      <mdb-container class="mb-4 content podcasts">
        <mdb-row class="mb-4">
          <mdb-col
            xl="3"
            sm="6"
            class="mb-4"
            v-for="(item,index) in podcasts"
            :key="'podcast'+index"
          >
            <router-link :to="'/podcast/'+item.id" class="podcasts-tile">
              <mdb-card class="top-bar-yellow">
                <mdb-card-image :src="item.docdata.imageurl" alt="Card image cap"></mdb-card-image>
                <mdb-card-body>
                  <div class="top-info-text mt-3 mb-1">EPISODE #{{item.docdata.episodeno}}</div>

                  <mdb-card-title>{{item.docdata.name}}</mdb-card-title>
                  <mdb-card-text>{{item.docdata.excerpt}}</mdb-card-text>
                  <!-- <span v-html="item.docdata.code"></span> -->
                </mdb-card-body>
                <mdb-card-footer small muted class="date">
                  <span class="lesson-count mb-3">{{item.docdata.dateadded | datetimemomentLT}}</span>
                  <span class="learn">
                    <span>
                      Go to the episode
                      <mdb-icon icon="angle-double-right" />
                    </span>
                  </span>
                </mdb-card-footer>
              </mdb-card>
            </router-link>
          </mdb-col>
        </mdb-row>
      </mdb-container>
    </mdb-container>

    <Footer></Footer>
  </div>
</template>

<script>
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import firebase from "firebase/app";
import { store } from "../store";

import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbCard,
  mdbCardImage,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbCardFooter,
  mdbBtn,
  mdbBadge,
  mdbIcon
} from "mdbvue";

export default {
  name: "Podcasts",
  created() {
    var refpodcasts = firebase
      .firestore()
      .collection("podcasts")
      .orderBy("episodeno");
    //console.log('hello', refpodcasts);
    refpodcasts.onSnapshot(querySnapshot => {
      //console.log("onsnapshot fired");
      this.podcasts = [];
      querySnapshot.forEach(doc => {
        this.podcasts.push({
          id: doc.id,
          docdata: doc.data()
        });
      });
    });
  },
  data() {
    return {
      podcasts: []
    };
  },
  components: {
    Nav,
    Footer,
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbCard,
    mdbCardImage,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbBtn,
    mdbBadge,
    mdbIcon
  }
};
</script>

<style>
</style>
